<!-- 高频词 听录音大小写字母配对 -->
<template>
  <el-form ref="ref_form" :model="interferenceForm" :rules="rules" label-width="120px">
    <div v-for="(item, index) in interferenceForm.dataList" :key="index" class="game-cutline">
      <el-form-item label="">
        <el-checkbox v-model="item.state" :true-label="1" :false-label="0">学习内容{{ index + 1 }}是否选用</el-checkbox>
      </el-form-item>
      <el-form-item :label="'学习内容' + (index + 1)" prop="wordName">
        <el-input v-model="item.wordName" disabled style="width: 350px;" />
      </el-form-item>
      <el-form-item v-if="item.state === 1" label="音频" :prop="'dataList.' + index + '.voice'" :rules="rules.voice">
        <themeUploadList style="width: 350px;" code="customVoice" :file-list.sync="item.voice" accept=".mp3,.wmv" :limit="1" tip="仅支持.mp3文件" />
      </el-form-item>
      <el-form-item
        v-if="item.state === 1"
        label="卡片图"
        :prop="'dataList.' + index + '.imgFile'"
        :rules="rules.imgFile"
      >
        <themeUploadAvatar code="customImg" :file-list.sync="item.imgFile" />
      </el-form-item>
      <el-form-item
        v-if="item.state === 1"
        label="干扰项字母"
        :prop="'dataList.' + index + '.letter'"
        :rules="rules.letter"
      >
        <el-input v-model="item.letter" placeholder="请输入干扰项字母" style="width: 350px;" />
      </el-form-item>
      <el-form-item
        v-if="item.state === 1"
        label="干扰项卡片图"
        :prop="'dataList.' + index + '.imgFile2'"
        :rules="rules.imgFile2"
      >
        <themeUploadAvatar code="customImg" :file-list.sync="item.imgFile2" />
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import themeUploadAvatar from '../../components/themeUploadAvatar'
import themeUploadList from '../../components/themeUploadList'
import { saveConfData } from '@api/courseManagement/api_quiz'
export default {
  components: {
    themeUploadAvatar,
    themeUploadList
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    moduleType: {
      type: String,
      default: ''
    },
    currentQuizType: {
      type: String,
      default: ''
    },
    gameList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      interferenceForm: {
        dataList: [
        ]
      },
      rules: {
        letter: [{ required: true, message: '请输入干扰项字母', trigger: 'blur' }],
        voice: [{ type: 'array', required: true, message: '请上传音频', trigger: 'change' }],
        imgFile: [{ type: 'array', required: true, message: '请上传卡片图', trigger: 'change' }],
        imgFile2: [{ type: 'array', required: true, message: '请上传干扰项卡片图', trigger: 'change' }]
      }

    }
  },
  computed: {
    ...mapState('courseStep', ['courseData', 'stepOptions', 'stepActive'])
  },
  watch: {
    gameList: function (val) {
      this.interferenceForm.dataList = []
      for (const item of this.gameList) {
        const name = item.questionMeans ? item.questionMeans.cardChartName : ''
        const rootUrl = item.questionMeans ? item.questionMeans.cardChartRootPath : ''
        const paramsUrl = item.questionMeans ? item.questionMeans.cardChartPath : ''

        const voiceName = item.questionMeans ? item.questionMeans.pronunciationName : ''
        const voiceFileName = item.questionMeans ? item.questionMeans.pronunciationFileName : ''
        const voiceParamsUrl = item.questionMeans ? item.questionMeans.pronunciationPath : ''
        const voice = item.questionMeans ? [{ name: voiceFileName, paramsFileName: voiceName, paramsUrl: voiceParamsUrl, url: voiceParamsUrl }] : []

        const name2 = item.interfereCustomMeans ? item.interfereCustomMeans[0].cardChartName : ''
        const rootUrl2 = item.interfereCustomMeans ? item.interfereCustomMeans[0].cardChartRootPath : ''
        const paramsUrl2 = item.interfereCustomMeans ? item.interfereCustomMeans[0].cardChartPath : ''
        const letter = item.interfereCustomMeans ? item.interfereCustomMeans[0].wordName : ''

        const imgFile = item.questionMeans ? [{ name: name, paramsFileName: name, paramsUrl: paramsUrl, url: rootUrl }] : []
        const imgFile2 = item.interfereCustomMeans ? [{ name: name2, paramsFileName: name2, paramsUrl: paramsUrl2, url: rootUrl2 }] : []
        this.interferenceForm.dataList.push({ state: item.state, studyId: item.studyId, wordName: item.wordName, url: item.cardChartRootPath, questionMeans: {}, imgFile: imgFile, imgFile2: imgFile2, letter: letter, voice: voice })
      }
    }
  },
  created () {

  },
  methods: {
    getOptions () {

      // getDictoryInfoByCode ('').then(res => {  })
    },

    saveGameOptions () {
      this.$refs.ref_form.validate(valid => {
        if (!valid) { return false }
        const arr = _.cloneDeep(this.interferenceForm.dataList)
        let checkTotal = 0
        for (var i = 0; i < arr.length; i++) {
          checkTotal = checkTotal + arr[i].state
        }
        if (checkTotal === 0) {
          this.$message.error(`请至少选中一条学习内容`)
          return false
        }

        this.interferenceForm.dataList.forEach((item) => {
          if (item.state === 1) {
            item.questionMeans.pronunciationName = item.voice[0].paramsFileName
            item.questionMeans.pronunciationPath = item.voice[0].paramsUrl

            item.questionMeans.cardChartName = item.imgFile[0].paramsFileName
            item.questionMeans.cardChartPath = item.imgFile[0].paramsUrl

            item.interfereCustomMeans = [{ wordName: item.letter, cardChartName: item.imgFile2[0].paramsFileName, cardChartPath: item.imgFile2[0].paramsUrl }]
          } else {
            item.questionMeans = null
            item.interfereCustomMeans = null
          }
        })
        const params = {
          curriculumId: this.courseData.teachingCurriculumId,
          curriculumType: this.courseData.curriculumType,
          quizType: this.currentQuizType,

          items: this.interferenceForm.dataList
        }

        saveConfData(params).then(res => {
          this.$message.success('操作成功')
          this.$emit('finishSave')
        })
      })
    }
  }
}
</script>

<style lang='scss'>
.setGame-first-img{
  display: inline-block;
  margin-right: 20px;
  text-align: center;

}
.setGame-sencond-img{
  display: inline-block;
  /*text-align: center;*/
  .themeUploadAvatar .btn-tip{
    display: inline-block;
    margin-left: 10px;
  }
}

</style>
